import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class SplashScreenConfigService {
	constructor(private service: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	getSplashScreenEnabled(): boolean {
		return this.service.get((config) => config.commonUi.isSplashScreenEnabled, false);
	}
}
